import { Injectable } from '@angular/core';
import { FavoriteItem } from 'models';
import { ApiService } from 'src/_utility/api';

@Injectable({
  providedIn: 'root'
})
export class FavoriteService {

  private favorites: FavoriteItem[] = undefined;

  constructor(
    private api: ApiService
  ) { }
  
  isFavorite(fidaCode: string): boolean {
    return this.getFavoriteItem(fidaCode) != null
  }

  getFavoriteItem(fidaCode: string): FavoriteItem {
    if(fidaCode == null) return null

    return this.favorites?.find(x => x.FidaCode == fidaCode) ?? null
  }

  getFavorites(): FavoriteItem[] {
    return this.favorites ?? []
  }

  loadFavorites(callback: () => void = null) {
      this.api.getFavorites()
        .then(data => {
          this.favorites = data;
          callback();
        })
        .catch(e => {
          this.favorites = [];
          callback();
        })
  }

  addProductToFavorites(product: FavoriteItem, callback: () => void = null) {
    if(product != null) {
      this.api.AddToFavorites(product)
        .then(data => {
          callback();
        })
        .catch(e => {
          console.log("error: ", e);
        })
    }
  }

  deleteProductFromFavorites(fidaCode: string, callback: () => void = null) {
    const favItem = this.getFavoriteItem(fidaCode);
    if(favItem != null) {
      this.api.DeleteFromFavorites(favItem.Id)
        .then(data => {
          callback();
        })
        .catch(e => {
          console.log("error: ", e);
        })
    }
  }

}
